import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
	// const config = useRuntimeConfig()
	Sentry.init({
		app: nuxtApp.vueApp,
		dsn: 'https://8126258ef384803c4cfc5200dc144eaa@o562637.ingest.us.sentry.io/4508579617374208',
		// environment: config.public.environment,
	})
})
